import Component from 'flarum/common/Component';
export default class PollImage extends Component {
  view() {
    const poll = this.attrs.poll;
    const url = poll.imageUrl();
    if (!url) return null;
    return m("div", {
      className: "PollImage"
    }, m("img", {
      className: "PollImage-image",
      src: url,
      srcset: poll.imageSrcset() ?? undefined,
      alt: poll.imageAlt() ?? '',
      loading: "lazy"
    }));
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollImage', PollImage);